module.exports = __webpack_public_path__ + "static/media/white_logo_one_repetition.5c0c92d2.gif";